import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const userAnalyticsController = {
  getUserAnalytics: ({ jwt, Authorization } = {}) => {
    return Utils.controller(
      "api/user-analytics/v1/getUserAnalytics",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default userAnalyticsController;
